import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import base64 from 'base64-arraybuffer';
import authApi from './api/auth';
import ws from './ws';
import crypto from './Crypto';
import localData from './localData';
import config from './config';
import errors from './errors';
import statusCodes from './statusCodes';
import { objectHasOwnProperty, getWsUrl } from './utils';
var MAX_PASSWORD_CHAR_LENGTH = 1000;
var MIN_PASSWORD_CHAR_LENGTH = 6;
var REMEMBER_ME_OPTIONS = {
  local: true,
  session: true,
  none: true
};
var KEY_NOT_FOUND_ON_SIGN_IN = "Device not recognized. This temporary password can only be used to sign in from a device you've signed in from before.";
var KEY_NOT_FOUND_ON_FORGOT_PASSWORD = "Device not recognized. Forgot password only works from a device you've signed in from before.";

var _checkSignedInState = function _checkSignedInState() {
  if (ws.reconnecting) throw new errors.Reconnecting();
  if (!ws.keys.init && ws.changePassword) throw new errors.UserMustChangePassword();
  if (!ws.keys.init) throw new errors.UserNotSignedIn();
};

var _parseGenericErrors = function _parseGenericErrors(e) {
  if (e.response) {
    if (e.response.data === 'Domain not whitelisted') {
      throw new errors.DomainNotWhitelisted(window.location.origin);
    } else if (e.response.data === 'App ID not valid') {
      throw new errors.AppIdNotValid();
    } else if (e.response.data === 'UserNotFound') {
      throw new errors.UserNotFound();
    } else if (e.response.status === statusCodes['Internal Server Error']) {
      throw new errors.InternalServerError();
    } else if (e.response.status === statusCodes['Gateway Timeout']) {
      throw new errors.Timeout();
    }
  } else if (e.message && e.message.indexOf('timeout') !== -1) {
    throw new errors.Timeout();
  }
};

var _connectWebSocket = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(session, seed, rememberMe, changePassword) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return ws.connect(session, seed, rememberMe, changePassword);

          case 3:
            _context.next = 11;
            break;

          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);

            _parseGenericErrors(_context.t0);

            if (!(_context.t0.message === 'Web Socket already connected')) {
              _context.next = 10;
              break;
            }

            throw new errors.UserAlreadySignedIn(_context.t0.username);

          case 10:
            throw _context.t0;

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 5]]);
  }));

  return function _connectWebSocket(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var _parseGenericUsernamePasswordError = function _parseGenericUsernamePasswordError(e) {
  if (e.response && e.response.data.error === 'UsernameTooLong') {
    throw new errors.UsernameTooLong(e.response.data.maxLen);
  } else if (e.response && e.response.data.error === 'PasswordAttemptLimitExceeded') {
    throw new errors.PasswordAttemptLimitExceeded(e.response.data.delay);
  }
};

var _parseSessionLengthError = function _parseSessionLengthError(e) {
  if (e.response && e.response.data) {
    var data = e.response.data;

    switch (data.error) {
      case 'SessionLengthTooShort':
        throw new errors.SessionLengthTooShort(data.minLen);

      case 'SessionLengthTooLong':
        throw new errors.SessionLengthTooLong(data.maxLen);
    }
  }
};

var _parseUserResponseError = function _parseUserResponseError(e, username) {
  _parseGenericErrors(e);

  _parseGenericUsernamePasswordError(e);

  if (e.response) {
    var data = e.response.data;

    switch (data) {
      case 'UsernameAlreadyExists':
        throw new errors.UsernameAlreadyExists(username);

      case 'TrialExceededLimit':
        throw new errors.TrialExceededLimit();

      case 'CurrentPasswordIncorrect':
        throw new errors.CurrentPasswordIncorrect();

      default: // continue

    }

    switch (data.error) {
      case 'EmailNotValid':
        throw new errors.EmailNotValid();

      case 'ProfileMustBeObject':
        throw new errors.ProfileMustBeObject();

      case 'ProfileKeyTooLong':
        throw new errors.ProfileKeyTooLong(data.maxLen, data.key);

      case 'ProfileValueMustBeString':
        throw new errors.ProfileValueMustBeString(data.key, data.value);

      case 'ProfileValueCannotBeBlank':
        throw new errors.ProfileValueCannotBeBlank(data.key);

      case 'ProfileValueTooLong':
        throw new errors.ProfileValueTooLong(data.maxLen, data.key, data.value);

      case 'ProfileHasTooManyKeys':
        throw new errors.ProfileHasTooManyKeys(data.maxKeys);

      case 'ProfileCannotBeEmpty':
        throw new errors.ProfileCannotBeEmpty();
    }
  }

  throw e;
};

var _calculateSessionLengthMs = function _calculateSessionLengthMs(sessionLength) {
  return sessionLength && sessionLength * 60 * 60 * 1000;
};

var _validateUsername = function _validateUsername(username) {
  if (typeof username !== 'string') throw new errors.UsernameMustBeString();
  if (username.length === 0) throw new errors.UsernameCannotBeBlank();
};

var _validatePassword = function _validatePassword(password) {
  if (typeof password !== 'string') throw new errors.PasswordMustBeString();
  if (password.length === 0) throw new errors.PasswordCannotBeBlank();
  if (password.length < MIN_PASSWORD_CHAR_LENGTH) throw new errors.PasswordTooShort(MIN_PASSWORD_CHAR_LENGTH);
  if (password.length > MAX_PASSWORD_CHAR_LENGTH) throw new errors.PasswordTooLong(MAX_PASSWORD_CHAR_LENGTH);
};

var _validateSignUpOrSignInInput = function _validateSignUpOrSignInInput(params) {
  if (typeof params !== 'object') throw new errors.ParamsMustBeObject();
  if (!objectHasOwnProperty(params, 'username')) throw new errors.UsernameMissing();
  if (!objectHasOwnProperty(params, 'password')) throw new errors.PasswordMissing();

  _validateUsername(params.username);

  _validatePassword(params.password);

  if (objectHasOwnProperty(params, 'rememberMe') && !REMEMBER_ME_OPTIONS[params.rememberMe]) {
    throw new errors.RememberMeValueNotValid(REMEMBER_ME_OPTIONS);
  }

  if (objectHasOwnProperty(params, 'sessionLength') && typeof params.sessionLength !== 'number') {
    throw new errors.SessionLengthMustBeNumber();
  }
};

var _generatePasswordToken = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(password, seed, passwordHashAlgo) {
    var passwordSalt, passwordHash, passwordHkdfKey, passwordTokenSalt, passwordToken, passwordBasedEncryptionKeySalt, passwordBasedEncryptionKey, passwordEncryptedSeed, passwordSalts, passwordBasedBackup;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            passwordSalt = crypto.scrypt.generateSalt();
            _context2.next = 3;
            return crypto.scrypt.hash(password, passwordSalt, passwordHashAlgo);

          case 3:
            passwordHash = _context2.sent;
            _context2.next = 6;
            return crypto.hkdf.importHkdfKeyFromString(passwordHash);

          case 6:
            passwordHkdfKey = _context2.sent;
            passwordTokenSalt = crypto.hkdf.generateSalt();
            _context2.next = 10;
            return crypto.hkdf.getPasswordToken(passwordHkdfKey, passwordTokenSalt);

          case 10:
            passwordToken = _context2.sent;
            passwordBasedEncryptionKeySalt = crypto.hkdf.generateSalt();
            _context2.next = 14;
            return crypto.aesGcm.getPasswordBasedEncryptionKey(passwordHkdfKey, passwordBasedEncryptionKeySalt);

          case 14:
            passwordBasedEncryptionKey = _context2.sent;
            _context2.next = 17;
            return crypto.aesGcm.encrypt(passwordBasedEncryptionKey, seed);

          case 17:
            passwordEncryptedSeed = _context2.sent;
            passwordSalts = {
              passwordSalt: base64.encode(passwordSalt),
              passwordTokenSalt: base64.encode(passwordTokenSalt)
            };
            passwordBasedBackup = {
              passwordBasedEncryptionKeySalt: base64.encode(passwordBasedEncryptionKeySalt),
              passwordEncryptedSeed: base64.encode(passwordEncryptedSeed)
            };
            return _context2.abrupt("return", {
              passwordToken: passwordToken,
              passwordSalts: passwordSalts,
              passwordBasedBackup: passwordBasedBackup
            });

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function _generatePasswordToken(_x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();

var _generateKeys = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(seed) {
    var masterKey, encryptionKeySalt, hmacKeySalt, keySalts, ecdsaKeyData, ecdhKeyData, ecKeyData;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return crypto.hkdf.importHkdfKey(seed);

          case 2:
            masterKey = _context3.sent;
            encryptionKeySalt = crypto.hkdf.generateSalt();
            hmacKeySalt = crypto.hkdf.generateSalt();
            keySalts = {
              encryptionKeySalt: base64.encode(encryptionKeySalt),
              hmacKeySalt: base64.encode(hmacKeySalt)
            };
            _context3.next = 8;
            return crypto.ecdsa.generateEcdsaKeyData(masterKey);

          case 8:
            ecdsaKeyData = _context3.sent;
            _context3.next = 11;
            return crypto.ecdh.generateEcdhKeyData(masterKey, ecdsaKeyData.ecdsaPrivateKey);

          case 11:
            ecdhKeyData = _context3.sent;
            delete ecdsaKeyData.ecdsaPrivateKey;
            delete ecdhKeyData.ecdhPrivateKey;
            ecKeyData = {
              ecdsaKeyData: ecdsaKeyData,
              ecdhKeyData: ecdhKeyData
            };
            return _context3.abrupt("return", {
              ecKeyData: ecKeyData,
              keySalts: keySalts
            });

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function _generateKeys(_x8) {
    return _ref3.apply(this, arguments);
  };
}();

var _generateKeysAndSignUp = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(username, password, seed, passwordHashAlgo, email, profile, sessionLength) {
    var _yield$_generatePassw, passwordToken, passwordSalts, passwordBasedBackup, _yield$_generateKeys, ecKeyData, keySalts, session;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _generatePasswordToken(password, seed, passwordHashAlgo);

          case 2:
            _yield$_generatePassw = _context4.sent;
            passwordToken = _yield$_generatePassw.passwordToken;
            passwordSalts = _yield$_generatePassw.passwordSalts;
            passwordBasedBackup = _yield$_generatePassw.passwordBasedBackup;
            _context4.next = 8;
            return _generateKeys(seed);

          case 8:
            _yield$_generateKeys = _context4.sent;
            ecKeyData = _yield$_generateKeys.ecKeyData;
            keySalts = _yield$_generateKeys.keySalts;
            _context4.prev = 11;
            _context4.next = 14;
            return authApi.signUp(username, passwordToken, ecKeyData, passwordSalts, keySalts, email, profile, passwordBasedBackup, sessionLength);

          case 14:
            session = _context4.sent;
            return _context4.abrupt("return", session);

          case 18:
            _context4.prev = 18;
            _context4.t0 = _context4["catch"](11);

            _parseSessionLengthError(_context4.t0);

            _parseUserResponseError(_context4.t0, username);

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[11, 18]]);
  }));

  return function _generateKeysAndSignUp(_x9, _x10, _x11, _x12, _x13, _x14, _x15) {
    return _ref4.apply(this, arguments);
  };
}();

var _validateProfile = function _validateProfile(profile) {
  if (typeof profile !== 'object') throw new errors.ProfileMustBeObject();
  var keyExists = false;

  for (var key in profile) {
    keyExists = true;
    var value = profile[key];
    if (typeof value !== 'string') throw new errors.ProfileValueMustBeString(key, value);
    if (!value) throw new errors.ProfileValueCannotBeBlank(key);
  }

  if (!keyExists) throw new errors.ProfileCannotBeEmpty();
};

var _validateSignUpInput = function _validateSignUpInput(params) {
  _validateSignUpOrSignInInput(params);

  if (params.profile) _validateProfile(params.profile);
  if (params.email && typeof params.email !== 'string') throw new errors.EmailNotValid();
};

var signUp = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params) {
    var password, profile, passwordHashAlgo, _params$rememberMe, rememberMe, username, email, appId, seed, sessionLength, _yield$_generateKeysA, sessionId, creationDate, expirationDate, userId, authToken, session, seedString;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;

            _validateSignUpInput(params);

            password = params.password, profile = params.profile, passwordHashAlgo = params.passwordHashAlgo, _params$rememberMe = params.rememberMe, rememberMe = _params$rememberMe === void 0 ? 'session' : _params$rememberMe;
            username = params.username.toLowerCase();
            email = params.email && params.email.toLowerCase();
            appId = config.getAppId();
            _context5.next = 8;
            return crypto.generateSeed();

          case 8:
            seed = _context5.sent;
            sessionLength = _calculateSessionLengthMs(params.sessionLength);
            _context5.next = 12;
            return _generateKeysAndSignUp(username, password, seed, passwordHashAlgo, email, profile, sessionLength);

          case 12:
            _yield$_generateKeysA = _context5.sent;
            sessionId = _yield$_generateKeysA.sessionId;
            creationDate = _yield$_generateKeysA.creationDate;
            expirationDate = _yield$_generateKeysA.expirationDate;
            userId = _yield$_generateKeysA.userId;
            authToken = _yield$_generateKeysA.authToken;
            session = {
              username: username,
              userId: userId,
              sessionId: sessionId,
              creationDate: creationDate,
              expirationDate: expirationDate,
              authToken: authToken
            };
            seedString = base64.encode(seed);
            localData.saveSeedString(rememberMe, appId, username, seedString);
            localData.signInSession(rememberMe, username, sessionId, creationDate, expirationDate);
            _context5.next = 24;
            return _connectWebSocket(session, seedString, rememberMe);

          case 24:
            return _context5.abrupt("return", ws.buildUserResult({
              username: username,
              userId: userId,
              authToken: authToken,
              email: email,
              profile: profile,
              userData: ws.userData
            }));

          case 27:
            _context5.prev = 27;
            _context5.t0 = _context5["catch"](0);
            _context5.t1 = _context5.t0.name;
            _context5.next = _context5.t1 === 'ParamsMustBeObject' ? 32 : _context5.t1 === 'UsernameMissing' ? 32 : _context5.t1 === 'UsernameAlreadyExists' ? 32 : _context5.t1 === 'UsernameCannotBeBlank' ? 32 : _context5.t1 === 'UsernameMustBeString' ? 32 : _context5.t1 === 'UsernameTooLong' ? 32 : _context5.t1 === 'PasswordMissing' ? 32 : _context5.t1 === 'PasswordCannotBeBlank' ? 32 : _context5.t1 === 'PasswordTooShort' ? 32 : _context5.t1 === 'PasswordTooLong' ? 32 : _context5.t1 === 'PasswordMustBeString' ? 32 : _context5.t1 === 'EmailNotValid' ? 32 : _context5.t1 === 'ProfileMustBeObject' ? 32 : _context5.t1 === 'ProfileCannotBeEmpty' ? 32 : _context5.t1 === 'ProfileHasTooManyKeys' ? 32 : _context5.t1 === 'ProfileKeyTooLong' ? 32 : _context5.t1 === 'ProfileValueMustBeString' ? 32 : _context5.t1 === 'ProfileValueCannotBeBlank' ? 32 : _context5.t1 === 'ProfileValueTooLong' ? 32 : _context5.t1 === 'RememberMeValueNotValid' ? 32 : _context5.t1 === 'SessionLengthMustBeNumber' ? 32 : _context5.t1 === 'SessionLengthTooShort' ? 32 : _context5.t1 === 'SessionLengthTooLong' ? 32 : _context5.t1 === 'TrialExceededLimit' ? 32 : _context5.t1 === 'AppIdNotSet' ? 32 : _context5.t1 === 'AppIdNotValid' ? 32 : _context5.t1 === 'DomainNotWhitelisted' ? 32 : _context5.t1 === 'UserAlreadySignedIn' ? 32 : _context5.t1 === 'ServiceUnavailable' ? 32 : 33;
            break;

          case 32:
            throw _context5.t0;

          case 33:
            throw new errors.UnknownServiceUnavailable(_context5.t0);

          case 34:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 27]]);
  }));

  return function signUp(_x16) {
    return _ref5.apply(this, arguments);
  };
}();

var signOut = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;

            if (ws.session.username) {
              _context6.next = 3;
              break;
            }

            throw new errors.UserNotSignedIn();

          case 3:
            _context6.prev = 3;
            _context6.next = 6;
            return ws.signOut();

          case 6:
            _context6.next = 12;
            break;

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](3);

            _parseGenericErrors(_context6.t0);

            throw _context6.t0;

          case 12:
            _context6.next = 21;
            break;

          case 14:
            _context6.prev = 14;
            _context6.t1 = _context6["catch"](0);
            _context6.t2 = _context6.t1.name;
            _context6.next = _context6.t2 === 'UserNotSignedIn' ? 19 : _context6.t2 === 'ServiceUnavailable' ? 19 : 20;
            break;

          case 19:
            throw _context6.t1;

          case 20:
            throw new errors.UnknownServiceUnavailable(_context6.t1);

          case 21:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 14], [3, 8]]);
  }));

  return function signOut() {
    return _ref6.apply(this, arguments);
  };
}();

var _getSeedStringFromPasswordBasedBackup = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(passwordHkdfKey, passwordBasedBackup) {
    var passwordBasedEncryptionKeySalt, passwordEncryptedSeed, passwordBasedEncryptionKey, seedFromBackup, seedStringFromBackup;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            passwordBasedEncryptionKeySalt = passwordBasedBackup.passwordBasedEncryptionKeySalt, passwordEncryptedSeed = passwordBasedBackup.passwordEncryptedSeed;
            _context7.next = 3;
            return crypto.aesGcm.getPasswordBasedEncryptionKey(passwordHkdfKey, base64.decode(passwordBasedEncryptionKeySalt));

          case 3:
            passwordBasedEncryptionKey = _context7.sent;
            _context7.next = 6;
            return crypto.aesGcm.decrypt(passwordBasedEncryptionKey, base64.decode(passwordEncryptedSeed));

          case 6:
            seedFromBackup = _context7.sent;
            seedStringFromBackup = base64.encode(seedFromBackup);
            return _context7.abrupt("return", seedStringFromBackup);

          case 9:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function _getSeedStringFromPasswordBasedBackup(_x17, _x18) {
    return _ref7.apply(this, arguments);
  };
}();

var _signInWrapper = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(username, passwordToken, sessionLength) {
    var apiSignInResult;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return authApi.signIn(username, passwordToken, sessionLength);

          case 3:
            apiSignInResult = _context8.sent;
            return _context8.abrupt("return", apiSignInResult);

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);

            _parseGenericErrors(_context8.t0);

            _parseGenericUsernamePasswordError(_context8.t0);

            _parseSessionLengthError(_context8.t0);

            if (!(_context8.t0.response && _context8.t0.response.data === 'Invalid password')) {
              _context8.next = 16;
              break;
            }

            throw new errors.UsernameOrPasswordMismatch();

          case 16:
            if (!(_context8.t0.response && _context8.t0.response.data === 'User pending deletion')) {
              _context8.next = 18;
              break;
            }

            throw new errors.UserPendingDeletion();

          case 18:
            throw _context8.t0;

          case 19:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));

  return function _signInWrapper(_x19, _x20, _x21) {
    return _ref8.apply(this, arguments);
  };
}();

var _getPasswordSaltsOverRestEndpoint = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(username) {
    var passwordSalts;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return authApi.getPasswordSalts(username);

          case 3:
            passwordSalts = _context9.sent;
            return _context9.abrupt("return", passwordSalts);

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](0);

            _parseGenericErrors(_context9.t0);

            _parseGenericUsernamePasswordError(_context9.t0);

            if (!(_context9.t0.response && _context9.t0.response.data === 'User not found')) {
              _context9.next = 13;
              break;
            }

            throw new errors.UsernameOrPasswordMismatch();

          case 13:
            throw _context9.t0;

          case 14:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 7]]);
  }));

  return function _getPasswordSaltsOverRestEndpoint(_x22) {
    return _ref9.apply(this, arguments);
  };
}();

var _getPasswordSaltsOverWebSocket = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var action, passwordSaltsResponse;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            action = 'GetPasswordSalts';
            _context10.next = 4;
            return ws.request(action);

          case 4:
            passwordSaltsResponse = _context10.sent;
            return _context10.abrupt("return", passwordSaltsResponse.data);

          case 8:
            _context10.prev = 8;
            _context10.t0 = _context10["catch"](0);

            _parseGenericErrors(_context10.t0);

            throw _context10.t0;

          case 12:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 8]]);
  }));

  return function _getPasswordSaltsOverWebSocket() {
    return _ref10.apply(this, arguments);
  };
}();

var _rebuildPasswordToken = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(password, passwordSalts, passwordHashAlgo) {
    var passwordSalt, passwordTokenSalt, passwordHash, passwordHkdfKey, passwordToken;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            passwordSalt = passwordSalts.passwordSalt, passwordTokenSalt = passwordSalts.passwordTokenSalt;
            _context11.next = 3;
            return crypto.scrypt.hash(password, new Uint8Array(base64.decode(passwordSalt)), passwordHashAlgo);

          case 3:
            passwordHash = _context11.sent;
            _context11.next = 6;
            return crypto.hkdf.importHkdfKeyFromString(passwordHash);

          case 6:
            passwordHkdfKey = _context11.sent;
            _context11.next = 9;
            return crypto.hkdf.getPasswordToken(passwordHkdfKey, base64.decode(passwordTokenSalt));

          case 9:
            passwordToken = _context11.sent;
            return _context11.abrupt("return", {
              passwordHkdfKey: passwordHkdfKey,
              passwordToken: passwordToken
            });

          case 11:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function _rebuildPasswordToken(_x23, _x24, _x25) {
    return _ref11.apply(this, arguments);
  };
}();

var signIn = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
    var username, password, passwordHashAlgo, _params$rememberMe2, rememberMe, appId, passwordSalts, _yield$_rebuildPasswo, passwordHkdfKey, passwordToken, sessionLength, apiSignInResult, userId, email, profile, passwordBasedBackup, protectedProfile, usedTempPassword, changePassword, session, seedString, savedSeedString, seedStringFromBackup;

    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;

            _validateSignUpOrSignInInput(params);

            username = params.username.toLowerCase();
            password = params.password, passwordHashAlgo = params.passwordHashAlgo, _params$rememberMe2 = params.rememberMe, rememberMe = _params$rememberMe2 === void 0 ? 'session' : _params$rememberMe2;
            appId = config.getAppId();
            _context12.next = 7;
            return _getPasswordSaltsOverRestEndpoint(username);

          case 7:
            passwordSalts = _context12.sent;
            _context12.next = 10;
            return _rebuildPasswordToken(password, passwordSalts, passwordHashAlgo);

          case 10:
            _yield$_rebuildPasswo = _context12.sent;
            passwordHkdfKey = _yield$_rebuildPasswo.passwordHkdfKey;
            passwordToken = _yield$_rebuildPasswo.passwordToken;
            sessionLength = _calculateSessionLengthMs(params.sessionLength);
            _context12.next = 16;
            return _signInWrapper(username, passwordToken, sessionLength);

          case 16:
            apiSignInResult = _context12.sent;
            userId = apiSignInResult.userId, email = apiSignInResult.email, profile = apiSignInResult.profile, passwordBasedBackup = apiSignInResult.passwordBasedBackup, protectedProfile = apiSignInResult.protectedProfile, usedTempPassword = apiSignInResult.usedTempPassword, changePassword = apiSignInResult.changePassword;
            session = _objectSpread(_objectSpread({}, apiSignInResult.session), {}, {
              username: username,
              userId: userId
            });

            if (changePassword) {
              _context12.next = 31;
              break;
            }

            savedSeedString = localData.getSeedString(appId, username);

            if (!(!savedSeedString && usedTempPassword)) {
              _context12.next = 25;
              break;
            }

            throw new errors.KeyNotFound(KEY_NOT_FOUND_ON_SIGN_IN);

          case 25:
            if (usedTempPassword) {
              _context12.next = 30;
              break;
            }

            _context12.next = 28;
            return _getSeedStringFromPasswordBasedBackup(passwordHkdfKey, passwordBasedBackup);

          case 28:
            seedStringFromBackup = _context12.sent;
            localData.saveSeedString(rememberMe, appId, username, seedStringFromBackup);

          case 30:
            seedString = seedStringFromBackup || savedSeedString;

          case 31:
            localData.signInSession(rememberMe, username, session.sessionId, session.creationDate, session.expirationDate);
            _context12.prev = 32;
            _context12.next = 35;
            return _connectWebSocket(session, seedString, rememberMe, changePassword);

          case 35:
            _context12.next = 42;
            break;

          case 37:
            _context12.prev = 37;
            _context12.t0 = _context12["catch"](32);

            if (!(usedTempPassword && _context12.t0.message === 'Invalid seed')) {
              _context12.next = 41;
              break;
            }

            throw new errors.KeyNotFound(KEY_NOT_FOUND_ON_SIGN_IN);

          case 41:
            throw _context12.t0;

          case 42:
            return _context12.abrupt("return", ws.buildUserResult({
              username: username,
              userId: userId,
              authToken: session.authToken,
              email: email,
              profile: profile,
              protectedProfile: protectedProfile,
              usedTempPassword: usedTempPassword,
              changePassword: changePassword,
              userData: ws.userData
            }));

          case 45:
            _context12.prev = 45;
            _context12.t1 = _context12["catch"](0);
            _context12.t2 = _context12.t1.name;
            _context12.next = _context12.t2 === 'ParamsMustBeObject' ? 50 : _context12.t2 === 'UsernameMissing' ? 50 : _context12.t2 === 'UsernameOrPasswordMismatch' ? 50 : _context12.t2 === 'UserPendingDeletion' ? 50 : _context12.t2 === 'UsernameCannotBeBlank' ? 50 : _context12.t2 === 'UsernameTooLong' ? 50 : _context12.t2 === 'UsernameMustBeString' ? 50 : _context12.t2 === 'PasswordMissing' ? 50 : _context12.t2 === 'PasswordCannotBeBlank' ? 50 : _context12.t2 === 'PasswordTooShort' ? 50 : _context12.t2 === 'PasswordTooLong' ? 50 : _context12.t2 === 'PasswordMustBeString' ? 50 : _context12.t2 === 'PasswordAttemptLimitExceeded' ? 50 : _context12.t2 === 'RememberMeValueNotValid' ? 50 : _context12.t2 === 'SessionLengthMustBeNumber' ? 50 : _context12.t2 === 'SessionLengthTooShort' ? 50 : _context12.t2 === 'SessionLengthTooLong' ? 50 : _context12.t2 === 'KeyNotFound' ? 50 : _context12.t2 === 'AppIdNotSet' ? 50 : _context12.t2 === 'AppIdNotValid' ? 50 : _context12.t2 === 'DomainNotWhitelisted' ? 50 : _context12.t2 === 'UserAlreadySignedIn' ? 50 : _context12.t2 === 'ServiceUnavailable' ? 50 : 51;
            break;

          case 50:
            throw _context12.t1;

          case 51:
            throw new errors.UnknownServiceUnavailable(_context12.t1);

          case 52:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 45], [32, 37]]);
  }));

  return function signIn(_x26) {
    return _ref12.apply(this, arguments);
  };
}();

var init = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
    var session;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;

            if (window.crypto.subtle) {
              _context13.next = 3;
              break;
            }

            throw new errors.WebCryptoUnavailable();

          case 3:
            if (!(typeof params !== 'object')) {
              _context13.next = 5;
              break;
            }

            throw new errors.ParamsMustBeObject();

          case 5:
            if (objectHasOwnProperty(params, 'appId')) {
              _context13.next = 7;
              break;
            }

            throw new errors.AppIdMissing();

          case 7:
            if (!(typeof params.appId !== 'string')) {
              _context13.next = 9;
              break;
            }

            throw new errors.AppIdMustBeString();

          case 9:
            if (!(params.appId.length === 0)) {
              _context13.next = 11;
              break;
            }

            throw new errors.AppIdCannotBeBlank();

          case 11:
            if (!(objectHasOwnProperty(params, 'updateUserHandler') && typeof params.updateUserHandler !== 'function')) {
              _context13.next = 13;
              break;
            }

            throw new errors.UpdateUserHandlerMustBeFunction();

          case 13:
            if (!(objectHasOwnProperty(params, 'sessionLength') && typeof params.sessionLength !== 'number')) {
              _context13.next = 15;
              break;
            }

            throw new errors.SessionLengthMustBeNumber();

          case 15:
            if (!(objectHasOwnProperty(params, 'allowServerSideEncryption') && typeof params.allowServerSideEncryption !== 'boolean')) {
              _context13.next = 17;
              break;
            }

            throw new errors.AllowServerSideEncryptionMustBeBoolean();

          case 17:
            config.configure(params);
            _context13.next = 20;
            return signInWithSession(params.appId, _calculateSessionLengthMs(params.sessionLength));

          case 20:
            session = _context13.sent;
            return _context13.abrupt("return", session);

          case 24:
            _context13.prev = 24;
            _context13.t0 = _context13["catch"](0);
            _context13.t1 = _context13.t0.name;
            _context13.next = _context13.t1 === 'WebCryptoUnavailable' ? 29 : _context13.t1 === 'ParamsMustBeObject' ? 29 : _context13.t1 === 'AppIdMissing' ? 29 : _context13.t1 === 'AppIdAlreadySet' ? 29 : _context13.t1 === 'AppIdMustBeString' ? 29 : _context13.t1 === 'AppIdCannotBeBlank' ? 29 : _context13.t1 === 'AppIdNotValid' ? 29 : _context13.t1 === 'DomainNotWhitelisted' ? 29 : _context13.t1 === 'UpdateUserHandlerMustBeFunction' ? 29 : _context13.t1 === 'SessionLengthMustBeNumber' ? 29 : _context13.t1 === 'SessionLengthTooShort' ? 29 : _context13.t1 === 'SessionLengthTooLong' ? 29 : _context13.t1 === 'AllowServerSideEncryptionMustBeBoolean' ? 29 : _context13.t1 === 'UserAlreadySignedIn' ? 29 : _context13.t1 === 'ServiceUnavailable' ? 29 : 30;
            break;

          case 29:
            throw _context13.t0;

          case 30:
            throw new errors.UnknownServiceUnavailable(_context13.t0);

          case 31:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 24]]);
  }));

  return function init(_x27) {
    return _ref13.apply(this, arguments);
  };
}();

var signInWithSession = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(appId, sessionLength) {
    var lastUsedUsername, currentSession, signedIn, sessionId, creationDate, expirationDate, rememberMe, savedSeedString, apiSignInWithSessionResult, _apiSignInWithSession, userId, authToken, username, email, profile, protectedProfile, session;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            currentSession = localData.getCurrentSession();

            if (currentSession) {
              _context14.next = 4;
              break;
            }

            return _context14.abrupt("return", {});

          case 4:
            signedIn = currentSession.signedIn, sessionId = currentSession.sessionId, creationDate = currentSession.creationDate, expirationDate = currentSession.expirationDate, rememberMe = currentSession.rememberMe;
            lastUsedUsername = currentSession.username;
            savedSeedString = localData.getSeedString(appId, lastUsedUsername);

            if (!(!signedIn || !savedSeedString || new Date() > new Date(expirationDate))) {
              _context14.next = 9;
              break;
            }

            return _context14.abrupt("return", {
              lastUsedUsername: lastUsedUsername
            });

          case 9:
            _context14.prev = 9;
            _context14.next = 12;
            return authApi.signInWithSession(sessionId, sessionLength);

          case 12:
            apiSignInWithSessionResult = _context14.sent;
            _context14.next = 22;
            break;

          case 15:
            _context14.prev = 15;
            _context14.t0 = _context14["catch"](9);

            _parseGenericErrors(_context14.t0);

            _parseSessionLengthError(_context14.t0);

            if (!(_context14.t0.response && _context14.t0.response.data === 'Session invalid')) {
              _context14.next = 21;
              break;
            }

            return _context14.abrupt("return", {
              lastUsedUsername: lastUsedUsername
            });

          case 21:
            throw _context14.t0;

          case 22:
            _apiSignInWithSession = apiSignInWithSessionResult, userId = _apiSignInWithSession.userId, authToken = _apiSignInWithSession.authToken, username = _apiSignInWithSession.username, email = _apiSignInWithSession.email, profile = _apiSignInWithSession.profile, protectedProfile = _apiSignInWithSession.protectedProfile; // overwrite local data if username has been changed on server

            if (username !== lastUsedUsername) {
              localData.saveSeedString(rememberMe, appId, username, savedSeedString);
              localData.removeSeedString(appId, lastUsedUsername);
            } // expirationDate should have been extended


            localData.signInSession(rememberMe, username, sessionId, creationDate, apiSignInWithSessionResult.expirationDate); // enable idempotent calls to init()

            if (!ws.connectionResolved) {
              _context14.next = 31;
              break;
            }

            if (!(ws.session.sessionId === sessionId)) {
              _context14.next = 30;
              break;
            }

            return _context14.abrupt("return", {
              user: ws.buildUserResult({
                username: username,
                userId: userId,
                authToken: ws.session.authToken,
                email: email,
                profile: profile,
                protectedProfile: protectedProfile,
                userData: ws.userData
              })
            });

          case 30:
            throw new errors.UserAlreadySignedIn(ws.session.username);

          case 31:
            session = _objectSpread(_objectSpread({}, currentSession), {}, {
              username: username,
              userId: userId,
              authToken: authToken
            });
            _context14.next = 34;
            return _connectWebSocket(session, savedSeedString, rememberMe);

          case 34:
            return _context14.abrupt("return", {
              user: ws.buildUserResult({
                username: username,
                userId: userId,
                authToken: authToken,
                email: email,
                profile: profile,
                protectedProfile: protectedProfile,
                userData: ws.userData
              })
            });

          case 37:
            _context14.prev = 37;
            _context14.t1 = _context14["catch"](0);

            if (!(_context14.t1.message === 'Invalid seed')) {
              _context14.next = 41;
              break;
            }

            return _context14.abrupt("return", {
              lastUsedUsername: lastUsedUsername
            });

          case 41:
            _parseGenericErrors(_context14.t1);

            throw _context14.t1;

          case 43:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 37], [9, 15]]);
  }));

  return function signInWithSession(_x28, _x29) {
    return _ref14.apply(this, arguments);
  };
}();

var _validateUpdatedUserInput = function _validateUpdatedUserInput(params) {
  if (!objectHasOwnProperty(params, 'username') && !objectHasOwnProperty(params, 'newPassword') && !objectHasOwnProperty(params, 'email') && !objectHasOwnProperty(params, 'profile')) {
    throw new errors.ParamsMissing();
  }

  var username = params.username,
      currentPassword = params.currentPassword,
      newPassword = params.newPassword,
      email = params.email,
      profile = params.profile;
  if (objectHasOwnProperty(params, 'username')) _validateUsername(username);

  if (objectHasOwnProperty(params, 'newPassword')) {
    if (!objectHasOwnProperty(params, 'currentPassword')) throw new errors.CurrentPasswordMissing();

    _validatePassword(currentPassword);

    _validatePassword(newPassword);
  } // if email or profile are falsey, will be set to false


  if (email && typeof email !== 'string') throw new errors.EmailNotValid();
  if (profile) _validateProfile(profile);
};

var _buildUpdateUserParams = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(params, newSeed) {
    var _yield$Promise$all, _yield$Promise$all2, currentPasswordSalts, newPasswordPromise, newKeyData, _yield$_rebuildPasswo2, passwordToken;

    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            if (params.username) params.username = params.username.toLowerCase();

            if (!params.newPassword) {
              _context15.next = 20;
              break;
            }

            _context15.next = 4;
            return Promise.all([_getPasswordSaltsOverWebSocket(), _generatePasswordToken(params.newPassword, newSeed || base64.decode(ws.seedString)), newSeed && _generateKeys(newSeed)]);

          case 4:
            _yield$Promise$all = _context15.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            currentPasswordSalts = _yield$Promise$all2[0];
            newPasswordPromise = _yield$Promise$all2[1];
            newKeyData = _yield$Promise$all2[2];
            _context15.next = 11;
            return _rebuildPasswordToken(params.currentPassword, currentPasswordSalts, params.passwordHashAlgo);

          case 11:
            _yield$_rebuildPasswo2 = _context15.sent;
            passwordToken = _yield$_rebuildPasswo2.passwordToken;
            params.currentPasswordToken = passwordToken;
            delete params.currentPassword; // new password

            params.passwordToken = newPasswordPromise.passwordToken;
            params.passwordSalts = newPasswordPromise.passwordSalts;
            params.passwordBasedBackup = newPasswordPromise.passwordBasedBackup;
            delete params.newPassword;
            if (newKeyData) params.newKeyData = newKeyData;

          case 20:
            if (params.email) params.email = params.email.toLowerCase();else if (objectHasOwnProperty(params, 'email')) params.email = false; // marks email for deletion

            if (!params.profile && objectHasOwnProperty(params, 'profile')) params.profile = false; // marks profile for deletion

            return _context15.abrupt("return", params);

          case 23:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function _buildUpdateUserParams(_x30, _x31) {
    return _ref15.apply(this, arguments);
  };
}();

var updateUser = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(params) {
    var startingUserId, newSeed, action, finalParams, response, updatedUser, newSeedString, _ws$session, sessionId, creationDate, expirationDate;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;

            if (!(typeof params !== 'object')) {
              _context16.next = 3;
              break;
            }

            throw new errors.ParamsMustBeObject();

          case 3:
            _validateUpdatedUserInput(params);

            if (!ws.reconnecting) {
              _context16.next = 6;
              break;
            }

            throw new errors.Reconnecting();

          case 6:
            if (ws.connectionResolved) {
              _context16.next = 8;
              break;
            }

            throw new errors.UserNotSignedIn();

          case 8:
            startingUserId = ws.session.userId; // need to generate new seed to rotate keys if user signed in with temp password to delete private data

            _context16.t0 = params.newPassword && !ws.keys.init && ws.changePassword;

            if (!_context16.t0) {
              _context16.next = 14;
              break;
            }

            _context16.next = 13;
            return crypto.generateSeed();

          case 13:
            _context16.t0 = _context16.sent;

          case 14:
            newSeed = _context16.t0;
            action = 'UpdateUser';
            _context16.next = 18;
            return _buildUpdateUserParams(_objectSpread({}, params), newSeed);

          case 18:
            finalParams = _context16.sent;

            if (!ws.reconnecting) {
              _context16.next = 21;
              break;
            }

            throw new errors.Reconnecting();

          case 21:
            if (ws.connectionResolved) {
              _context16.next = 23;
              break;
            }

            throw new errors.UserNotSignedIn();

          case 23:
            if (!(!ws.session || startingUserId !== ws.session.userId)) {
              _context16.next = 25;
              break;
            }

            throw new errors.ServiceUnavailable();

          case 25:
            _context16.prev = 25;

            if (finalParams.username) {
              localData.saveSeedString(ws.rememberMe, config.getAppId(), finalParams.username, ws.seedString);
            }

            _context16.next = 29;
            return ws.request(action, finalParams);

          case 29:
            response = _context16.sent;
            updatedUser = response.data.updatedUser;
            ws.handleUpdateUser(updatedUser); // must have rotated keys successfully

            if (!(newSeed && ws.session && startingUserId === ws.session.userId)) {
              _context16.next = 39;
              break;
            }

            newSeedString = base64.encode(newSeed);
            _context16.next = 36;
            return ws.rotateKeys(newSeedString, finalParams.newKeyData);

          case 36:
            localData.saveSeedString(ws.rememberMe, config.getAppId(), updatedUser.username, newSeedString);
            _ws$session = ws.session, sessionId = _ws$session.sessionId, creationDate = _ws$session.creationDate, expirationDate = _ws$session.expirationDate;
            localData.signInSession(ws.rememberMe, updatedUser.username, sessionId, creationDate, expirationDate);

          case 39:
            _context16.next = 44;
            break;

          case 41:
            _context16.prev = 41;
            _context16.t1 = _context16["catch"](25);

            _parseUserResponseError(_context16.t1, finalParams.username);

          case 44:
            _context16.next = 53;
            break;

          case 46:
            _context16.prev = 46;
            _context16.t2 = _context16["catch"](0);
            _context16.t3 = _context16.t2.name;
            _context16.next = _context16.t3 === 'ParamsMustBeObject' ? 51 : _context16.t3 === 'ParamsMissing' ? 51 : _context16.t3 === 'UsernameAlreadyExists' ? 51 : _context16.t3 === 'UsernameMustBeString' ? 51 : _context16.t3 === 'UsernameCannotBeBlank' ? 51 : _context16.t3 === 'UsernameTooLong' ? 51 : _context16.t3 === 'CurrentPasswordMissing' ? 51 : _context16.t3 === 'CurrentPasswordIncorrect' ? 51 : _context16.t3 === 'PasswordAttemptLimitExceeded' ? 51 : _context16.t3 === 'PasswordMustBeString' ? 51 : _context16.t3 === 'PasswordCannotBeBlank' ? 51 : _context16.t3 === 'PasswordTooShort' ? 51 : _context16.t3 === 'PasswordTooLong' ? 51 : _context16.t3 === 'EmailNotValid' ? 51 : _context16.t3 === 'ProfileMustBeObject' ? 51 : _context16.t3 === 'ProfileCannotBeEmpty' ? 51 : _context16.t3 === 'ProfileHasTooManyKeys' ? 51 : _context16.t3 === 'ProfileKeyTooLong' ? 51 : _context16.t3 === 'ProfileValueMustBeString' ? 51 : _context16.t3 === 'ProfileValueCannotBeBlank' ? 51 : _context16.t3 === 'ProfileValueTooLong' ? 51 : _context16.t3 === 'AppIdNotSet' ? 51 : _context16.t3 === 'AppIdNotValid' ? 51 : _context16.t3 === 'UserNotFound' ? 51 : _context16.t3 === 'UserNotSignedIn' ? 51 : _context16.t3 === 'TooManyRequests' ? 51 : _context16.t3 === 'ServiceUnavailable' ? 51 : 52;
            break;

          case 51:
            throw _context16.t2;

          case 52:
            throw new errors.UnknownServiceUnavailable(_context16.t2);

          case 53:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 46], [25, 41]]);
  }));

  return function updateUser(_x32) {
    return _ref16.apply(this, arguments);
  };
}();

var deleteUser = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
    var username, action;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;

            _checkSignedInState();

            username = ws.session.username;
            localData.removeSeedString(config.getAppId(), username);
            localData.removeCurrentSession();
            _context17.prev = 5;
            action = 'DeleteUser';
            _context17.next = 9;
            return ws.request(action);

          case 9:
            _context17.next = 15;
            break;

          case 11:
            _context17.prev = 11;
            _context17.t0 = _context17["catch"](5);

            _parseGenericErrors(_context17.t0);

            throw _context17.t0;

          case 15:
            ws.close();
            _context17.next = 25;
            break;

          case 18:
            _context17.prev = 18;
            _context17.t1 = _context17["catch"](0);
            _context17.t2 = _context17.t1.name;
            _context17.next = _context17.t2 === 'UserMustChangePassword' ? 23 : _context17.t2 === 'UserNotSignedIn' ? 23 : _context17.t2 === 'UserNotFound' ? 23 : _context17.t2 === 'TooManyRequests' ? 23 : _context17.t2 === 'ServiceUnavailable' ? 23 : 24;
            break;

          case 23:
            throw _context17.t1;

          case 24:
            throw new errors.UnknownServiceUnavailable(_context17.t1);

          case 25:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 18], [5, 11]]);
  }));

  return function deleteUser() {
    return _ref17.apply(this, arguments);
  };
}();

var _getMasterKeyAndKeyNotFoundMessage = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(appId, username) {
    var seedString, seed, masterKey;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            seedString = localData.getSeedString(appId, username);

            if (seedString) {
              _context18.next = 3;
              break;
            }

            throw new errors.KeyNotFound(KEY_NOT_FOUND_ON_FORGOT_PASSWORD);

          case 3:
            seed = base64.decode(seedString);
            _context18.next = 6;
            return crypto.hkdf.importHkdfKey(seed);

          case 6:
            masterKey = _context18.sent;
            return _context18.abrupt("return", masterKey);

          case 8:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function _getMasterKeyAndKeyNotFoundMessage(_x33, _x34) {
    return _ref18.apply(this, arguments);
  };
}();

var forgotPassword = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(params) {
    var username, appId, url, forgotPasswordWs;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.prev = 0;

            if (!(typeof params !== 'object')) {
              _context20.next = 3;
              break;
            }

            throw new errors.ParamsMustBeObject();

          case 3:
            if (!(objectHasOwnProperty(params, 'deleteEndToEndEncryptedData') && typeof params.deleteEndToEndEncryptedData !== 'boolean')) {
              _context20.next = 5;
              break;
            }

            throw new errors.DeleteEndToEndEncryptedDataMustBeBoolean();

          case 5:
            if (objectHasOwnProperty(params, 'username')) {
              _context20.next = 7;
              break;
            }

            throw new errors.UsernameMissing();

          case 7:
            _validateUsername(params.username);

            username = params.username.toLowerCase();
            appId = config.getAppId();
            url = "".concat(getWsUrl(config.getEndpoint()), "/api/auth/forgot-password?appId=").concat(appId, "&username=").concat(encodeURIComponent(username), "&userbaseJsVersion=").concat(config.USERBASE_JS_VERSION);
            forgotPasswordWs = new WebSocket(url + (objectHasOwnProperty(params, 'deleteEndToEndEncryptedData') ? "&deleteEndToEndEncryptedData=".concat(params.deleteEndToEndEncryptedData) : ''));
            _context20.next = 14;
            return new Promise(function (resolve, reject) {
              setTimeout(function () {
                return reject(new errors.Timeout());
              }, 15000);

              forgotPasswordWs.onerror = function () {
                return reject(new errors.ServiceUnavailable());
              };

              forgotPasswordWs.onmessage = /*#__PURE__*/function () {
                var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(e) {
                  var message, masterKey, encryptedForgotPasswordToken, dhPrivateKey, sharedKey, forgotPasswordToken, _masterKey, ecdsaKeyEncryptionKeySalt, encryptedEcdsaPrivateKey, _forgotPasswordToken, ecdsaKeyEncryptionKey, ecdsaPrivateKey, rawEcdsaPrivateKey, signedForgotPasswordToken, data;

                  return _regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                      switch (_context19.prev = _context19.next) {
                        case 0:
                          _context19.prev = 0;
                          message = JSON.parse(e.data);
                          _context19.t0 = message.route;
                          _context19.next = _context19.t0 === 'ReceiveEncryptedToken' ? 5 : _context19.t0 === 'ReceiveToken' ? 28 : _context19.t0 === 'SuccessfullyForgotPassword' ? 54 : _context19.t0 === 'Error' ? 56 : _context19.t0 === 'Ping' ? 69 : 70;
                          break;

                        case 5:
                          _context19.next = 7;
                          return _getMasterKeyAndKeyNotFoundMessage(appId, username);

                        case 7:
                          masterKey = _context19.sent;
                          // if client decrypts encrypted token successfully, proves to server it has the user's key
                          encryptedForgotPasswordToken = new Uint8Array(message.encryptedForgotPasswordToken.data);
                          _context19.next = 11;
                          return crypto.diffieHellman.importKeyFromMaster(masterKey, base64.decode(message.dhKeySalt));

                        case 11:
                          dhPrivateKey = _context19.sent;
                          _context19.next = 14;
                          return crypto.diffieHellman.getSharedKeyWithServer(dhPrivateKey);

                        case 14:
                          sharedKey = _context19.sent;
                          _context19.prev = 15;
                          _context19.t1 = base64;
                          _context19.next = 19;
                          return crypto.aesGcm.decrypt(sharedKey, encryptedForgotPasswordToken);

                        case 19:
                          _context19.t2 = _context19.sent;
                          forgotPasswordToken = _context19.t1.encode.call(_context19.t1, _context19.t2);
                          _context19.next = 26;
                          break;

                        case 23:
                          _context19.prev = 23;
                          _context19.t3 = _context19["catch"](15);
                          throw new errors.KeyNotFound(KEY_NOT_FOUND_ON_FORGOT_PASSWORD);

                        case 26:
                          forgotPasswordWs.send(JSON.stringify({
                            action: 'ForgotPassword',
                            params: {
                              forgotPasswordToken: forgotPasswordToken
                            }
                          }));
                          return _context19.abrupt("break", 71);

                        case 28:
                          _context19.next = 30;
                          return _getMasterKeyAndKeyNotFoundMessage(appId, username);

                        case 30:
                          _masterKey = _context19.sent;
                          ecdsaKeyEncryptionKeySalt = message.ecdsaKeyEncryptionKeySalt, encryptedEcdsaPrivateKey = message.encryptedEcdsaPrivateKey, _forgotPasswordToken = message.forgotPasswordToken;
                          _context19.next = 34;
                          return crypto.ecdsa.importEcdsaKeyEncryptionKeyFromMaster(_masterKey, base64.decode(ecdsaKeyEncryptionKeySalt));

                        case 34:
                          ecdsaKeyEncryptionKey = _context19.sent;
                          _context19.prev = 35;
                          _context19.next = 38;
                          return crypto.aesGcm.decrypt(ecdsaKeyEncryptionKey, base64.decode(encryptedEcdsaPrivateKey));

                        case 38:
                          rawEcdsaPrivateKey = _context19.sent;
                          _context19.next = 41;
                          return crypto.ecdsa.getPrivateKeyFromRawPrivateKey(rawEcdsaPrivateKey);

                        case 41:
                          ecdsaPrivateKey = _context19.sent;
                          _context19.next = 47;
                          break;

                        case 44:
                          _context19.prev = 44;
                          _context19.t4 = _context19["catch"](35);
                          throw new errors.KeyNotFound(KEY_NOT_FOUND_ON_FORGOT_PASSWORD);

                        case 47:
                          _context19.t5 = base64;
                          _context19.next = 50;
                          return crypto.ecdsa.sign(ecdsaPrivateKey, base64.decode(_forgotPasswordToken));

                        case 50:
                          _context19.t6 = _context19.sent;
                          signedForgotPasswordToken = _context19.t5.encode.call(_context19.t5, _context19.t6);
                          forgotPasswordWs.send(JSON.stringify({
                            action: 'ForgotPassword',
                            params: {
                              signedForgotPasswordToken: signedForgotPasswordToken
                            }
                          }));
                          return _context19.abrupt("break", 71);

                        case 54:
                          // server has sent the email
                          resolve();
                          return _context19.abrupt("break", 71);

                        case 56:
                          data = message.data;
                          _context19.t7 = data.name;
                          _context19.next = _context19.t7 === 'UsernameTooLong' ? 60 : _context19.t7 === 'AppIdNotValid' ? 61 : _context19.t7 === 'UserNotFound' ? 62 : _context19.t7 === 'UserEmailNotFound' ? 63 : 64;
                          break;

                        case 60:
                          throw new errors.UsernameTooLong(data.maxLen);

                        case 61:
                          throw new errors.AppIdNotValid();

                        case 62:
                          throw new errors.UserNotFound();

                        case 63:
                          throw new errors.UserEmailNotFound();

                        case 64:
                          if (!(message.status === statusCodes['Internal Server Error'])) {
                            _context19.next = 68;
                            break;
                          }

                          throw new errors.ServiceUnavailable();

                        case 68:
                          throw new errors.UnknownServiceUnavailable(data);

                        case 69:
                          return _context19.abrupt("break", 71);

                        case 70:
                          reject(new Error("Received unknown message from userbase-server: ".concat(e.data)));

                        case 71:
                          _context19.next = 76;
                          break;

                        case 73:
                          _context19.prev = 73;
                          _context19.t8 = _context19["catch"](0);
                          reject(_context19.t8);

                        case 76:
                        case "end":
                          return _context19.stop();
                      }
                    }
                  }, _callee19, null, [[0, 73], [15, 23], [35, 44]]);
                }));

                return function (_x36) {
                  return _ref20.apply(this, arguments);
                };
              }();
            });

          case 14:
            forgotPasswordWs.close();
            _context20.next = 24;
            break;

          case 17:
            _context20.prev = 17;
            _context20.t0 = _context20["catch"](0);
            _context20.t1 = _context20.t0.name;
            _context20.next = _context20.t1 === 'ParamsMustBeObject' ? 22 : _context20.t1 === 'UsernameMissing' ? 22 : _context20.t1 === 'UsernameMustBeString' ? 22 : _context20.t1 === 'UsernameCannotBeBlank' ? 22 : _context20.t1 === 'UsernameTooLong' ? 22 : _context20.t1 === 'AppIdNotSet' ? 22 : _context20.t1 === 'AppIdNotValid' ? 22 : _context20.t1 === 'KeyNotFound' ? 22 : _context20.t1 === 'UserNotFound' ? 22 : _context20.t1 === 'UserEmailNotFound' ? 22 : _context20.t1 === 'ServiceUnavailable' ? 22 : 23;
            break;

          case 22:
            throw _context20.t0;

          case 23:
            throw new errors.UnknownServiceUnavailable(_context20.t0);

          case 24:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, null, [[0, 17]]);
  }));

  return function forgotPassword(_x35) {
    return _ref19.apply(this, arguments);
  };
}();

export default {
  signUp: signUp,
  signOut: signOut,
  signIn: signIn,
  init: init,
  updateUser: updateUser,
  deleteUser: deleteUser,
  forgotPassword: forgotPassword
};